import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaCloudUploadAlt } from "react-icons/fa";
import { postCommunicationType, postCommunicationTypeSave, getCommunicationTypeDetails, deleteCommunicationType, postCommunicationTypeSaveStatus } from '../../apiservices/ApiServices';


const CommunicationType = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [statusModal, setStatusModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [data, setData] = useState([]);

    const [previewImage, setPreviewImage] = useState(null);

    const [deleteData, setDeleteData] = useState([]);
    const [deleteList, setDeleteList] = useState([]);

    const postCommunicationTypes = async (postData) => {
        setLoading(true);
        try {
            const res = await postCommunicationType(postData);
            setData(res.data.data.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdate = async () => {
        let postData = {
            length: 100
        }
        try {

            const res = await postCommunicationType(postData);
            setData(res.data.data.records);

        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postCommunicationTypes(postData);
    }, []);


    const columns = useMemo(
        () => [
            {
                Header: "Com. Type Icon",
                accessor: "com_type_icon",
            },
            {
                Header: "Com. Type Name",
                accessor: "com_type_name",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete', 'add Status']
    const subActions = []

    const emptyStatement = {
        id: '',
        name: '',
        comTypeIcon: '',
        displayOrder: '',
        isActive: 1,

        status: {
            statusId: '',
            statusName: '',
            statusOrder: '',
        }
    }

    const mapApiDataToFormikValues = (apiData) => {
        return apiData?.map(item => ({
            statusId: item?.status_id || '',
            statusName: item?.status_name || '',
            statusOrder: item?.sort_order || '',
        })) || [];
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        status: [emptyStatement]
    });

    const add = () => {
        setFieldValue('status', [...values.status, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const removedItem = values.status[index];
        if (removedItem?.statusId) {
            setDeleteList((prev) => [...prev, removedItem.stageId]);
        }
        const updated = values.status.filter((_, i) => i !== index);
        setFieldValue('status', updated);
    };

    //deleted_com_type_ids: deleteList || [],
    const transformFormValuesToPostData = (values) => {
        return {
            com_type_id: values.id,
            status: values.status.map((item) => ({
                status_id: item?.statusId,
                status_name: item?.statusName,
                sort_order: item?.statusOrder,
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            if (addModal) {
                const formData = new FormData();
                formData.append("com_type_id", values.id || '');
                formData.append("com_type_name", values.name);
                formData.append("com_type_icon", values.comTypeIcon);
                formData.append("sort_order", values.displayOrder);
                formData.append("is_active", values.isActive || 0);

                try {
                    const res = await postCommunicationTypeSave(formData);
                    toast.success(res.data.message);
                    postUpdate();
                    setLoadings(false);
                    setAddModal(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (statusModal) {
                const postData = transformFormValuesToPostData(values);
                try {
                    const res = await postCommunicationTypeSaveStatus(postData);
                    toast.success(res.data.message);
                    postUpdate();
                    setLoadings(false);
                    setStatusModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        setStatusModal(false);
        formik.resetForm();
    };

    const fetchFileFromUrl = async (url, fileName) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const file = new File([blob], fileName,
                {
                    type: blob.type || 'image/jpeg'
                });

            return file;
        } catch (error) {
            console.error('Error fetching file:', error);
            return null;
        }
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        try {

            const res = await getCommunicationTypeDetails(rowData?.com_type_id);
            setLoadings(false);

            setFieldValue('id', res.data.data.com_type_id);
            setFieldValue('name', res.data.data.com_type_name);
            setFieldValue('displayOrder', res.data.data.sort_order);
            setFieldValue('isActive', res.data.data.is_active ? 1 : 0)

            if (res.data.data?.com_type_icon && res.data.data?.com_type_icon_name) {
                const file = await fetchFileFromUrl(
                    res.data.data?.com_type_icon,
                    res.data.data?.com_type_icon_name
                );
                if (file) {
                    setFieldValue('comTypeIcon', file);
                    setPreviewImage(URL.createObjectURL(file));
                }
            }

            setAddModal(true);
            setIsEdit(true);
        } catch (error) {
            setLoadings(false);
            setIsEdit(false);
        }
    };

    const handleStatus = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        try {

            const res = await getCommunicationTypeDetails(rowData?.com_type_id);
            setLoadings(false);
            setFieldValue('id', res.data.data.com_type_id);

            if (res?.data?.data?.statuses?.length) {
                const prefill = mapApiDataToFormikValues(res.data.data?.statuses);
                setFieldValue('status', prefill);
            }

            setStatusModal(true);
        } catch (error) {
            setLoadings(false);
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.com_type_id);
        setFieldValue('name', rowData?.com_type_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteCommunicationType(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdate();
            setFieldValue('id', '');
            setFieldValue('name', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Communication Type" active="Communication Type" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Communication Type</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => { setIsEdit(false); setPreviewImage(null); setAddModal(true); }}
                                                    >
                                                        Add New
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onAddUpdateStatus={handleStatus}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit' : 'Add New'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">com. Type Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">display Order</label>
                                <input type="text"
                                    name="displayOrder"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.displayOrder}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.displayOrder && touched.displayOrder && (
                                    <p className="errormsg">{errors.displayOrder}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">com. Type Icone</label>
                                <div className='fileuploadbox'>
                                    <p className='filename'>{values?.comTypeIcon?.name || ''}</p>
                                    <div className='uploadbtn'>
                                        <FaCloudUploadAlt />
                                    </div>
                                    <input
                                        type='file'
                                        id="comTypeIcon"
                                        name="comTypeIcon"
                                        autoComplete='off'
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={(event) => {
                                            const file = event.currentTarget.files[0];
                                            setFieldValue('comTypeIcon', file);
                                            setPreviewImage(URL.createObjectURL(file));
                                        }}
                                        onBlur={handleBlur}
                                    />
                                </div>

                                {previewImage && (
                                    <div className="selected_img">
                                        <img src={previewImage} alt='' title='' />
                                    </div>
                                )}

                                {errors.comTypeIcon && touched.comTypeIcon && (
                                    <p className="errormsg">{errors.comTypeIcon}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">Is Active</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name='isActive'
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.isActive}
                                            checked={values.isActive === 1}
                                            onChange={(e) => setFieldValue('isActive', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? 'Update' : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={statusModal}
                handleClose={() => setStatusModal(false)}
                title={isEdit ? 'Edit' : 'Add New'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.status.map((items, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>items {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                    {values.status.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Status Name</label>
                                            <input type="text"
                                                name="statusName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={items.statusName}
                                                onChange={(e) => setFieldValue(`status[${index}].statusName`, e.target.value)}
                                            />
                                            {errors?.status?.[index]?.statusName &&
                                                touched?.status?.[index]?.statusName && (
                                                    <p className="errormsg">{errors.status[index].statusName}</p>
                                                )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">display Order</label>
                                            <input type="text"
                                                name="statusOrder"
                                                className="form-control"
                                                autoComplete='off'
                                                value={items.statusOrder}
                                                onChange={(e) => setFieldValue(`status[${index}].statusOrder`, e.target.value)}
                                            />
                                            {errors?.status?.[index]?.statusOrder &&
                                                touched?.status?.[index]?.statusOrder && (
                                                    <p className="errormsg">{errors.status[index].statusOrder}</p>
                                                )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}

                    <div className='modalfooters'>
                        <div className='button-boxs grid'>

                            <button type='submit' className='btn btn-primary'>Submit</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>


            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.name}</span> Communication TYpe?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default CommunicationType